import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import styles from "./OnboardingPopup.module.scss";
import PopupInner from "./components/PopupInner";

const OnboardingPopup = ({ close }) => {
  const [showExpressTour, setShowExpressTour] = useState(false);
  const { onboardingStep } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const onboardingPopUpBackgroundRef = useRef(null);
  const onboardingPopUpRef = useRef(null);
  const [hasClickedOutside, setHasClickedOutside] = useState(false);

  const handleExpressTour = (event) => {
    event.stopPropagation();
    setShowExpressTour(!showExpressTour);
    dispatch({
      type: "SET_ONBOARDING_STEP",
      payload: 1,
    });
  };

  const handleSkip = (event) => {
    event.stopPropagation();
    localStorage.setItem("onboardingSeen", true);
    // set a flag to indicate that the user has skipped the onboarding tour
    localStorage.setItem("onboardingSkipped", true);
    close();
  };

  const handleOnClosePopup = () => {
    dispatch({
      type: "SET_ONBOARDING_STEP",
      payload: 0,
    });
    // Set localStorage flag onboardingSeen so the user does not see the onboarding again after viewing
    // the first time unless they clear their localStorage
    localStorage.setItem("onboardingSeen", true);
    // remove the onboardingSkipped flag so the user is no longer prompted
    // to show the onboarding popup now they have completed the journey
    localStorage.removeItem("onboardingSkipped");
    close();
  };

  // Prevent body scroll when the onboarding pop up is open
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = null;
    };
  }, []);

  // Handle clicking outside of the onboarding popup here
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Using two separate refs as on the initial popup we want to allow the users to interact with the buttons
      // so they can access or skip the tour, otherwise the popup would just end up closing wherever we clicked.
      if (
        (onboardingStep === 0 &&
          onboardingPopUpRef.current &&
          !onboardingPopUpRef.current.contains(event.target)) ||
        (onboardingStep > 0 &&
          onboardingPopUpBackgroundRef.current &&
          onboardingPopUpBackgroundRef.current.contains(event.target))
      ) {
        setHasClickedOutside(true);

        // Reset the onboarding step to 0 and set onboardingSeen localStorage flag
        handleOnClosePopup();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasClickedOutside, onboardingStep]);

  if (hasClickedOutside) return null;

  return (
    <div
      data-testid="onboarding-popup"
      className={`${styles.onboardingPopupContainer} ${
        showExpressTour ? styles["onboardingPopupContainer--tourActive"] : ""
      }`}
      ref={onboardingPopUpBackgroundRef}
    >
      {showExpressTour ? null : (
        <PopupInner
          skip={(e) => handleSkip(e)}
          showExpressTour={(e) => handleExpressTour(e)}
          componentRef={onboardingPopUpRef}
        />
      )}
    </div>
  );
};

OnboardingPopup.propTypes = {
  close: PropTypes.func,
};

export default OnboardingPopup;
